import { Grid, GridItem } from '@chakra-ui/react'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import ProductCard from '../Components/ProductCard'

const WomenProducts = () => {
  let [data,setdata]=useState([])
  const GetProduct = async () => {
    let result = await axios.get("http://localhost:4000/WomenProducts")
    console.log("result: ", result.data); 
    setdata(result.data)
  }

  useEffect(()=>{
    GetProduct()
  },[])

  return (
    <>
    <Grid w="80%" m="auto" mt={10} templateColumns='repeat(3, 1fr)' gap={5}>
    {data.map((el)=>{
        return <GridItem><ProductCard pro={el} id={el.id} url={el.url} productname={el.product_name} productprice={el.product_price} avl={el.availablity} productdetails={el.product_details}/></GridItem>
      })}
      
    </Grid>
      
    </>
  )
}

export default WomenProducts